import { defineMessages } from "react-intl";

const baseId = "t.app.";

export default defineMessages({
  pageTitle: {
    id: baseId + "pageTitle",
    defaultMessage: "STORICO RICHIESTE",
  },
  loading: {
    id: baseId + "loading",
    defaultMessage: "Download in progress",
  },
});
